<template>
	<section class="highlights-slider">
		<div class="row row-header align-center">
			<div class="columns column12">
				<h2>{{ header }}</h2>
			</div>
		</div>
		<div class="slide-row">
			<div ref="emblaCarousel" class="embla">
				<div class="embla__container">
					<nuxt-link
						v-for="item in items"
						:key="item.ID"
						:to="localePath(`/${item.filename}`)"
						class="slick-item embla__slide fade-animate up"
					>
						<picture>
							<source v-if="item.imageRoundWebp" :srcset="item.imageRoundWebp" type="image/webp" />
							<source :srcset="item.imageRound" />
							<img loading="lazy" :src="item.imageRound" :alt="item.imageRoundAlt" />
						</picture>
						<h3>{{ item.header }}</h3>
					</nuxt-link>
					<div v-for="i in 3" :key="i" class="slick-item embla__slide desktop-filler" />
				</div>
			</div>
		</div>

		<div class="embla-controls">
			<div class="row">
				<div class="columns column12">
					<button
						v-for="(_, index) in items"
						:key="index"
						:class="{ active: selectedScrollSnap === index }"
						@click="scrollCarouselTo(index)"
					></button>
				</div>
			</div>
		</div>
		<div class="row row-content align-center">
			<div class="columns column12">
				<p>
					<i>{{ content }}</i>
				</p>
			</div>
		</div>
	</section>
</template>

<script setup>
import emblaCarouselVue from 'embla-carousel-vue';

const localePath = useLocalePath();

defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});

const [emblaCarousel, emblaApi] = emblaCarouselVue({ loop: false, duration: 20 });
const selectedScrollSnap = ref(0);
const scrollCarouselTo = (index) => {
	emblaApi.value.scrollTo(index);
	selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
};

onMounted(() => {
	if (!emblaApi.value) {
		return;
	}

	emblaApi.value.on('select', () => {
		selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
	});
});
</script>

<style lang="scss" scoped>
.highlights-slider {
	padding: 20px 0;
	background: linear-gradient(0deg, var(--primary-background-color) 63%, var(--alternating-background-color) 50%);

	h3 {
		color: #fff;
		font-size: 30px;
		margin: 20px 0 0;
	}
}

.row-header p {
	font-family: var(--heading-font-family);
}

.row-content {
	padding: 25px 0 75px;
	color: #fff;
	max-width: 840px;
}

.slide-row {
	width: 98%;
}

.slick-item {
	margin: 0 2.5% 0 0;
}

.embla {
	overflow: hidden;
	position: relative;
}

.embla-controls {
	.row {
		max-width: 840px;
		margin: 50px auto 25px;
	}

	button {
		width: calc(100% / 6);
		background: rgb(238 231 228 / 25%);
		height: 5px;
		border: none;
		outline: none;
		cursor: pointer;

		&:hover,
		&.active {
			background: rgb(238 231 228 / 100%);
		}
	}
}

/* stylelint-disable */
.embla__container {
	display: flex;
}

.embla__slide {
	flex: 0 0 18%;
	min-width: 0;
	text-align: center;

	img {
		border-radius: 50%;
		height: auto;
	}
}

/* stylelint-enable */

@media (min-width: 1401px) {
	.slide-row {
		padding-left: calc(50vw - 690px);
	}
}

@media (max-width: 1400px) {
	.slide-row {
		padding-left: 1em;
		margin: 0 0 0 2%;
	}
}

@media (min-width: 1081px) {
	.embla-controls {
		.row {
			max-width: 840px;
			margin: 50px auto 25px;
			text-align: center;
		}

		button {
			width: calc(100% / 4);
			display: none;

			&:nth-child(2),
			&:first-child {
				display: inline-block;
			}
		}
	}
}

/* stylelint-disable */

@media (max-width: 1080px) {
	.embla__slide {
		flex: 0 0 36%;
	}

	.slide-row {
		padding-left: 0;
		margin: 0;
		width: 100%;
	}

	.embla-controls {
		text-align: center;
	}
}

@media (max-width: 880px) {
	.embla__slide {
		flex: 0 0 66%;
	}

	.embla {
		&::before,
		&::after {
			width: 12vw;
		}
	}
}

@media (max-width: 680px) {
	.embla__slide {
		flex: 0 0 66%;
	}
}
/* stylelint-enable */
</style>
